import { isValid } from "date-fns";
import * as yup from "yup";

import { getIntl } from "context/SettingsProvider";
import { ValidationError } from "yup";

export const PlannedDateValidationSchema = () => {
  const intl = getIntl();

  return yup.object({
    startTime: yup
      .string()
      .nullable()
      .test({
        name: "type",
        test: function (value) {
          if (value && !isValid(new Date(value))) {
            const errors = [
              new ValidationError(
                intl.formatMessage({ id: "validation.date" }),
                value,
                "startDate"
              ),
              new ValidationError(
                intl.formatMessage({ id: "validation.time" }),
                value,
                "startTime"
              ),
            ];
            return this.createError({ message: () => errors });
          }
          return true;
        },
      }),
    stopTime: yup
      .string()
      .nullable()
      .test({
        name: "type",
        message: intl.formatMessage({ id: "validation.time" }),
        test: function (value) {
          if (value && !isValid(new Date(value))) {
            const errors = [
              new ValidationError(intl.formatMessage({ id: "validation.date" }), value, "stopDate"),
              new ValidationError(intl.formatMessage({ id: "validation.time" }), value, "stopTime"),
            ];
            return this.createError({ message: () => errors });
          }
          return true;
        },
      })
      .test({
        name: "min",
        test: function (value) {
          if (!!value && new Date(value) < new Date(this.parent.startTime)) {
            var errors = [
              new ValidationError(
                intl.formatMessage({ id: "times.endTimeAfterStartTime" }),
                value,
                "stopTime"
              ),
            ];

            const stopDateCopy = new Date(value);
            stopDateCopy.setHours(0, 0, 0, 0);
            const startDateCopy = new Date(this.parent.startTime);
            startDateCopy.setHours(0, 0, 0, 0);

            if (stopDateCopy < startDateCopy) {
              errors.push(
                new ValidationError(
                  intl.formatMessage({ id: "times.endDateAfterStartDate" }),
                  value,
                  "stopDate"
                )
              );
            }

            return this.createError({ message: () => errors });
          }
          return true;
        },
      }),
  });
};
